<template>
    <b-modal ref="modal" size="lg" centered :title="$t('WORKINGGROUPEVENTCHILDFORM')" @close="close()" no-close-on-backdrop
        no-close-on-esc hide-footer>
        <div class="d-block mt-2">
            <div role="group" class="b-form-group form-group" v-if="formData != null">
                <div class="form-row mb-lg">
                    <div class="col-sm-12 table-responsive">
                        <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                            <thead>
                                <tr>
                                    <th>
                                        {{ $t('NAME') }}
                                    </th>
                                    <th>{{ $t('ATTENDANCE') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in response.root" :key="item.notificationId" aria-rowindex="1"
                                    class=" table-ellipsis">
                                    <td>{{ item.fullname }}</td>
                                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('YES')"
                                            v-bind:off="$t('NO')" :pill="true"
                                            :checked="(item.attendance == 'didcome') ? true : false"
                                            v-on:change="submitData(item)" /></td>
                                </tr>
                            </tbody>
                        </table>
                        <nav>
                            <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                            </pagination>
                        </nav>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <b-btn class="mr-2 button-cancel" @click="close()">{{ $t('CLOSE') }}</b-btn>
            </div>
        </div>
    </b-modal>
</template>


<script>
import {
    mapGetters,
}
    from 'vuex';
import cSwitch from '../../components/lib/Switch'
import Api from '@/api/working_group/WorkingGroup';

export default
    {
        name: 'WorkingGroupChildEventForm',
        props: ['value'],
        components: {
            cSwitch
        },
        data() {
            const me = this;

            return {
                columns: [
                    {
                        key: 'fullname',
                        name: me.$t('NAME'),
                    },
                    {
                        id: 'actions',
                        name: me.$t('ACTIONS'),
                    },
                ],
                formError: {},
                formData: null,
                response:
                    {},
                pagination:
                {
                    query: '',
                    currentPage: 1,
                    limit: 25,
                    searchTimeout: false,
                    companyId: '',
                    initialId: null,
                    sort: null,
                    readingType: null,
                },
            };
        },
        methods:
        {
            async getData() {
                const me = this;
                try {
                    const data = await Api.selectChildrenInGroup(me.getParams);
                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    me.response = data;
                }
                catch (e) {
                    me.$notify.notice(e);
                }
                finally {
                    me.loading = false;
                }
            },
            async submitData(item) {
                const me = this;
                try {
                    item.attendance = (item.attendance == 'didcome') ? 'didntcome' : 'didcome';
                    item.workingGroupId = me.formData.workingGroupId;
                    item.eventId = me.formData.eventId;
                    const data = await Api.upsertChildEventAttendance(item);
                    me.$notify.notice(data);

                    if (data.error) {
                        me.formError = data;
                    }

                    me.getData();
                }
                catch (e) {
                    console.log(e);
                    me.$notify.notice(e);
                }
            },
            close() {
                const me = this;
                me.formError = {};
                me.formData = null;
                me.$emit('close');
            },
        },
        watch:
        {
            async formData(val) {
                const me = this;
                if (val != null) {
                    await me.getData();
                    me.$refs.modal.show();
                }
                else {
                    me.$refs.modal.hide();
                }
            },
            value(val) {
                const me = this;
                if (val != null) {
                    me.formData = { ...val };
                }
                else {
                    me.formData = null;
                }
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
            getParams() {
                const me = this;
                const data = {
                    ...me.pagination,
                };
                data.status = me.childStatus;
                data.userId = me.logopedId;
                data.searchQuerry = me.searchQuerry;
                data.start = (data.currentPage - 1) * data.limit;
                data.workingGroupId = me.formData.workingGroupId;
                data.eventId = me.formData.eventId;
                return data;
            },
        },
    };
</script>
